module.exports = "/packs/as_img04-42c88f640248858094670cf3cd36be7f.png";